import qs from 'querystring';
import { isNil, omitBy } from 'lodash';
import { toDeviceConfiguration, toDeviceConfigurationPage, toRequestDeviceConfiguration } from './DeviceConfigurationTransformer';

import type { DeviceConfiguration, PageableContent, Sort, UpdateDeviceConfiguration } from '@cobliteam/common-types';

import type { Configuration, IRequest } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';

export class DeviceConfigurationRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public getDevicesConfiguration = (page?: number, size?: number, sort?: Sort, deviceIds?: string[]): Promise<PageableContent<DeviceConfiguration>> => {
    const sortString = sort && Object.values(sort).join();
    const deviceIdsString = deviceIds?.join();

    const queryString = qs.stringify(omitBy({ page, size, sort: sortString, deviceIds: deviceIdsString }, isNil));

    const requestData: IRequest = {
      endpoint: `/betoneira-configuration/configuration?${queryString}`,
      method: HttpMethod.GET,
    };
    return this.requester.request(requestData).then((response) => toDeviceConfigurationPage(response.data));
  };

  public postDevicesConfiguration = (devicesConfiguration: UpdateDeviceConfiguration[]): Promise<UpdateDeviceConfiguration[]> => {
    const requestData: IRequest = {
      endpoint: '/betoneira-configuration/configuration',
      method: HttpMethod.POST,
      body: JSON.stringify({
        devices_configuration: devicesConfiguration.map(toRequestDeviceConfiguration),
      }),
    };
    return this.requester.request(requestData).then((response) => response.data.map(toDeviceConfiguration));
  };
}

export default DeviceConfigurationRequester;
